export default "__VITE_ASSET__s6qoY8EN__"